import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let num = Math.round(value);
    
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/round.pipe.ts